import React, { useCallback } from 'react';
import { Box, Stack, Divider, Chip } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

const projectStatus = [
  { id: 0, value: '', label: '전체', color: 'warning' },
  { id: 1, value: '0', label: '수주품의', color: 'secondary' },
  { id: 2, value: '1', label: '발주', color: 'success' },
  { id: 3, value: '2', label: '세금계산서', color: 'error' },
  { id: 4, value: '3', label: '채권', color: 'primary' },
];

const ProjectStatusList = ({ filters, onFilters }) => {
  //착수보고/분석설계/구축(이행)/완료(검수)
  //22.12.3.  수주 - 발주 - 세금계산서 - 채권

  const handleFilterStatus = useCallback(
    (value) => {
      onFilters('searchGrade', value);
    },
    [onFilters],
  );

  return (
    <Box className="status-chip-list"
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItem: 'center',
        m: 1,
      }}
    >
      <Stack
        direction="row"
        divider={<Divider orientation="vertical" flexItem />}
        spacing={2}
      >
        <Box>
          {projectStatus &&
            projectStatus.map((st, index) => (
              <Chip
                sx={{ mr: 2 }}
                key={index}
                icon={<CircleIcon />}
                label={st.label}
                variant={
                  st.value === filters?.searchGrade ? 'contained' : 'outlined'
                }
                color={st.color}
                onClick={() => handleFilterStatus(st.value)}
              />
            ))}
        </Box>
      </Stack>
    </Box>
  );
};

export default ProjectStatusList;
